// extracted by mini-css-extract-plugin
export default {"container":"AnfAS1BopsU3AOICLFNl","description":"wQKGyIa4swJz6DPO5l6Z","title":"bF4aq8FRS3Av1oJawwgW","image":"tYanCPr7crvF2_sajb26"};